import { useEffect, useRef, useState } from "react";
import { trackEvent } from "@/lib/analytics";

/** A positive number from a text field, or 0. */
export const num = (v: string) => {
  const n = parseFloat(v);
  return Number.isFinite(n) && n > 0 ? n : 0;
};
export const inRange = (n: number, lo: number, hi: number) => n >= lo && n <= hi;

/** "an 8 ft ceiling", "an 84 in. sofa", "a 9 ft ceiling". */
export const aOrAn = (n: number | string) => (/^(8|11|18)(\D|$)|^8/.test(String(n)) ? "an" : "a");

/** One analytics event per settled result, not per keystroke. */
export function useToolTracking(tool: string, mode: string, resultKey: string | undefined) {
  const last = useRef("");
  useEffect(() => {
    if (!resultKey) return;
    const id = `${mode}:${resultKey}`;
    const t = setTimeout(() => {
      if (last.current === id) return;
      last.current = id;
      trackEvent("use_tool", { tool, mode, result: resultKey });
    }, 1500);
    return () => clearTimeout(t);
  }, [tool, mode, resultKey]);
}

/** Fetches a /tools-data/*.json file written by scripts/generate-tool-data.mjs.
 *  It exists only in a built site; in local dev the picks simply don't show. */
export function useToolData<T>(file: string): T | null {
  const [data, setData] = useState<T | null>(null);
  useEffect(() => {
    let cancelled = false;
    fetch(`/tools-data/${file}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => !cancelled && setData(d))
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [file]);
  return data;
}
